import React, { Component } from 'react';
import SideBar from './StaffComponents/Sidebar';
import { Redirect, Route, Link, Switch } from 'react-router-dom';
import ContentArea from './StaffComponents/ContentArea';
import superagent from 'superagent';
import ReactLoading from 'react-loading';



class Lecturer extends Component {

  constructor(props) {
    super(props);

     this.state={
       access_token:this.props.admin_token,
       user_details:this.props.admin_details,
       loading:true,
       loaded_successfully:false,
       api_error_message:"",
       server_changes_made:""
     }
  }

  componentWillMount(){

  }

  render() {
    const _this=this;


    if(! this.props.loginStatus)
    {
      return(<Redirect to = "/staff/login"/>);
    }

      return (
        <div className = "wrapper">
          <SideBar staff_details = {_this.props.lecturer_details}/>
          <ContentArea      staff_details = {_this.props.lecturer_details}
                            base_url={_this.props.base_url}
                            loginStatus= {this.props.loginStatus}
                            renderInThousands = {this.props.renderInThousands}
                            updateStaffDetails={_this.props.updateLecturerDetails}/>
        </div>

      );

    //}


  }




}

export default Lecturer;
